import { Button } from "@mui/material";
import { usePutNoticeDocumentApproveMutation } from "apis/FireSafety/FireSafetyObservation";
import {
  FIRE_AND_EMERGENCY_SERVICES_HOD,
  FIRE_EMERGENCY_CHIEF_FIRE_OFFICER,
} from "common/constant";
import ConfirmationDialog from "Components/Common/ConfirmationDialog";
import { t } from "i18next";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { isAuthorizedUser } from "utils";

function NoticeActionButtons({ noticeData, setNoticePreview }) {
  const { id, url, approvedBy, rejectedBy } = noticeData || {};
  const { roles } = useSelector((state) => state.Login);

  const [isApproveButtonClicked, setIsApproveButtonClicked] = useState(false);

  const isCFO = isAuthorizedUser(roles, [FIRE_EMERGENCY_CHIEF_FIRE_OFFICER]);
  const isHOD = isAuthorizedUser(roles, [FIRE_AND_EMERGENCY_SERVICES_HOD]);

  const canApprove =
    !!url &&
    !rejectedBy &&
    ((isCFO && !approvedBy) ||
      (isHOD && approvedBy === FIRE_EMERGENCY_CHIEF_FIRE_OFFICER));

  const canReject =
    !!url &&
    !rejectedBy &&
    ((isCFO && !approvedBy && !rejectedBy) ||
      (isHOD &&
        !rejectedBy &&
        approvedBy === FIRE_EMERGENCY_CHIEF_FIRE_OFFICER));

  const [approvedOrRejectNotice, { isLoading: isNoticeApproving }] =
    usePutNoticeDocumentApproveMutation();

  const handleNoticeAction = async (status) => {
    try {
      await approvedOrRejectNotice({
        noticeId: id,
        status,
      });
      setIsApproveButtonClicked(false);
      setNoticePreview(null);
    } catch (error) {}
  };

  return (
    <>
      {isApproveButtonClicked && (
        <ConfirmationDialog
          message="Are you sure you want to approve Notice?"
          onCancel={() => {
            setIsApproveButtonClicked(false);
          }}
          onConfirm={() => handleNoticeAction(1)}
          isOpen={isApproveButtonClicked}
          title="Warning"
          variant="warning"
          isLoading={isNoticeApproving}
        />
      )}

      <>
        {canApprove && (
          <Button
            variant="contained"
            className="mt-2"
            color="success"
            onClick={() => setIsApproveButtonClicked(true)}
          >
            {t("Approve")}
          </Button>
        )}

        {canReject && (
          <Button
            variant="contained"
            className="mt-2"
            color="warning"
            onClick={() => handleNoticeAction(2)}
          >
            {t("Reject")}
          </Button>
        )}
      </>
    </>
  );
}

export default NoticeActionButtons;
